<template>
    <div v-if="showPopup">
        <pop-up-modal-content
            maxWidth="none"
            maxHeight="none"
            :backgroundColor="backgroundColor"
            justifyContentPopUp="center"
            alignItemsPopUp="center"
            marginPopUp="0"
            paddingPopUpBody="0px"
            overflowBodyPopUp="visible"
        >
            <div
                class="modal show modal-coupon"
                style="opacity: 1"
                tabindex="-1"
                role="dialog"
                id="modal-pop-up-coupon"
                aria-labelledby="modal-pop-up-coupon"
                aria-hidden="true"
                @click="closeModal()"
            >
                <div class="modal-dialog" role="document" @click.stop>
                    <div class="modal-content">
                        <i class="fas fa-times" @click="closeModal()"></i>
                        <div class="modal-body">
                            <div v-if="imageSrc" :class="['coupon-image', {'coupon-image-only': !hasCoupon}]">
                                <a v-if="!hasCoupon && pop_up.link" :href="pop_up.link">
                                    <img :src="imageSrc" :alt="pop_up.name" loading="lazy">
                                </a>
                                <img v-else :src="imageSrc" :alt="pop_up.name" loading="lazy">
                            </div>
                            <div v-if="hasCoupon" class="coupon-content">
                                <h3 v-if="pop_up.title" v-html="pop_up.title"></h3>
                                <div v-if="pop_up.description" class="coupon-description" v-html="pop_up.description"></div>
                                <div v-if="couponCode" class="coupon-code">{{ couponCode }}</div>
                                <div class="coupon-actions">
                                    <button type="button" class="btn-primary-coupon" :disabled="isLoading" @click="applyCoupon">
                                        {{ primaryButtonText }}
                                    </button>
                                    <button type="button" class="btn-secondary-coupon" :disabled="isLoading" @click="rejectCoupon">
                                        {{ secondaryButtonText }}
                                    </button>
                                </div>
                                <div v-if="confirmationMessage" class="coupon-confirmation">
                                    {{ confirmationMessage }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </pop-up-modal-content>
    </div>
</template>

<script>
import { CPopUpModalContent } from '../Styles/PopUp/styled'
import * as SessionStorageService from '../../services/SessionStorageService'

export default {
    name: 'PopUpCoupon',
    props: {
        pop_up: { required: true },
        set: { required: true },
        show_popup: { required: true }
    },
    components: {
        'pop-up-modal-content': CPopUpModalContent
    },
    data() {
        return {
            showPopup: false,
            isLoading: false,
            timeoutId: null,
            confirmationMessage: null
        }
    },
    computed: {
        backgroundColor() {
            return this.set?.background_color ?? '#ffffff'
        },
        storageKey() {
            return 'popup-coupon-'+ this.pop_up?.id
        },
        couponCode() {
            return this.pop_up?.coupon?.code ?? null
        },
        hasCoupon() {
            return !!this.couponCode
        },
        imageSrc() {
            if(this.pop_up?.image_path) {
                return this.$pathFilesSystem + '/' + this.pop_up.image_path
            }

            if(this.pop_up?.url_image) {
                return this.pop_up.url_image
            }

            return null
        },
        primaryButtonText() {
            return this.pop_up?.primary_button_text ?? 'Quero desconto agora'
        },
        secondaryButtonText() {
            return this.pop_up?.secondary_button_text ?? 'Não gosto de promoções'
        },
        showAfterSeconds() {
            return Number(this.pop_up?.show_after_seconds ?? 0)
        }
    },
    methods: {
        closeModal() {
            this.showPopup = false
            SessionStorageService.set(this.storageKey, {showed: true})
        },
        closeOtherCouponPopups(event) {
            if(event.detail?.id !== this.pop_up?.id) {
                this.showPopup = false
            }
        },
        rejectCoupon() {
            this.closeModal()
        },
        schedulePopup() {
            const getKey = SessionStorageService.get(this.storageKey)
            if(getKey?.showed) {
                return
            }

            const delay = Math.max(this.showAfterSeconds, 0) * 1000
            this.timeoutId = setTimeout(() => {
                this.showPopup = true
                window.dispatchEvent(new CustomEvent('popup-coupon-opened', {
                    detail: { id: this.pop_up?.id }
                }))
                SessionStorageService.set(this.storageKey, {showed: true})
            }, delay)
        },
        async applyCoupon() {
            if(!this.hasCoupon) {
                this.goToFallback()
                return
            }

            try {
                this.isLoading = true
                localStorage.setItem('@cart_coupom_code', this.couponCode)
                this.confirmationMessage = 'Cupom salvo! Ele será aplicado no checkout.'
                setTimeout(() => {
                    this.isLoading = false
                    this.showPopup = false
                }, 1600)
            } catch(error) {
                this.isLoading = false
                alert(error?.response?.data?.msg ?? error?.msg ?? error)
            }
        },
        goToFallback() {
            this.closeModal()
        }
    },
    mounted() {
        window.addEventListener('popup-coupon-opened', this.closeOtherCouponPopups)
        this.schedulePopup()
    },
    beforeDestroy() {
        if(this.timeoutId) {
            clearTimeout(this.timeoutId)
        }
        window.removeEventListener('popup-coupon-opened', this.closeOtherCouponPopups)
    }
}
</script>

<style scoped>
.modal-coupon {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.modal-coupon .modal-dialog {
    margin: 0 auto;
    width: 860px;
    max-width: calc(100vw - 40px);
}

.modal-coupon .modal-content {
    width: 100%;
    max-width: calc(100vw - 40px);
    max-height: calc(100vh - 40px);
    background: #fff;
    border: 0;
    box-shadow: none;
    overflow: visible;
}

.modal-coupon .modal-body {
    max-height: calc(100vh - 40px);
    overflow: auto;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.coupon-image,
.coupon-content {
    display: flex;
    align-items: center;
    justify-content: center;
}

.coupon-image {
    flex: 1 1 50%;
    min-width: 0;
}

.coupon-image-only {
    flex: 1 1 100%;
    width: 100%;
}

.coupon-image-only a {
    display: block;
    width: 100%;
}

.coupon-image img {
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 40px);
    object-fit: cover;
    display: block;
}

.coupon-content {
    flex: 1 1 50%;
    min-width: 280px;
    padding: 32px;
    flex-direction: column;
    text-align: center;
}

.coupon-content h3 {
    margin: 0 0 12px;
    font-size: 2.4rem;
    line-height: 1.2;
}

.coupon-description {
    font-size: 1.4rem;
    line-height: 1.5;
    margin-bottom: 18px;
}

.coupon-code {
    width: 100%;
    padding: 12px 16px;
    margin-bottom: 18px;
    border: 1px dashed #999;
    font-size: 2rem;
    font-weight: 700;
    letter-spacing: 0;
}

.coupon-actions {
    display: flex;
    gap: 10px;
    width: 100%;
}

.coupon-confirmation {
    width: 100%;
    margin-top: 12px;
    font-size: 1.4rem;
    font-weight: 600;
    color: #1f7a3a;
}

.coupon-actions button {
    flex: 1 1 0;
    min-height: 42px;
    padding: 8px 12px;
    border: 1px solid #333;
    cursor: pointer;
    font-weight: 600;
}

.btn-primary-coupon {
    background: #333;
    color: #fff;
}

.btn-secondary-coupon {
    background: #fff;
    color: #333;
}

@media (max-width: 767px) {
    .modal-coupon .modal-body {
        flex-direction: column;
    }

    .coupon-image,
    .coupon-content {
        width: 100%;
    }

    .coupon-image img {
        max-height: 45vh;
        object-fit: contain;
    }

    .coupon-image-only img {
        max-height: calc(100vh - 40px);
    }

    .coupon-content {
        min-width: 0;
        padding: 22px;
    }

    .coupon-actions {
        flex-direction: column;
    }
}
</style>
